var RoutingUtils = /** @class */ (function () {
    function RoutingUtils() {
    }
    /**
     * We need this function to read the pathname from the url bar
     * The angular Router works different and will in AppComponent give '/'
     */
    RoutingUtils.getPath = function () {
        return window.location.pathname;
    };
    return RoutingUtils;
}());
export { RoutingUtils };
